import { VITE_PAR_CHILD_WEBSITE_LINK } from '../helpers/env';

export const CookieKeys = {
  TOKEN: 'gwa_fe_token',
  USER_TYPE: 'gwa_fe_user_type',
  ORG_UUID: 'gwa_fe_default_org_uuid',
  ONBOARDING_COMPLETE: 'gwa_fe_onboarding_complete',
  REDIRECT_ROUTE: 'gwa_fe_redirect_route',
  PAYMENT_GATEWAY: 'gwa_fe_payment_gateway',
  IS_EXPRESS_REGISTRATION: 'gwa_fe_is_express_registration',
  ERROR_MESSAGE: 'gwa_fe_error_message',
};

export const AppValues = {
  par_website:
    import.meta.env.VITE_PAR_WEBSITE_LINK || 'https://proudafricanroots.com',
  localhostPaymentRedirectUrl: import.meta.env
    .VITE_LOCALHOST_PAYMENT_REDIRECT_URL,
};

export const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const Themes = {
  milk: '#FFFDF5',
  text: {
    100: '#0D0E1236',
    200: '#0D0E1266',
    300: '#0D0E1286',
    400: '#0D0E1299',
    500: '#0D0E12',
  },
  placeholder: '#0D0E1266',
  brown: {
    50: 'hsl(26, 100%, 79%)',
    100: 'hsl(26, 100%, 69%)',
    200: 'hsl(26, 100%, 59%)',
    300: 'hsl(26, 100%, 49%)',
    400: 'hsl(26, 100%, 39%)',
    500: 'hsl(26, 100%, 29%)',
    600: 'hsl(26, 100%, 26%)',
    700: 'hsl(26, 100%, 23%)',
    800: 'hsl(26, 100%, 20%)',
    900: 'hsl(26, 100%, 18%)',
  },
  stroke: {
    300: ' #E4E4EC',
  },
  org: {
    primary: '#189DDD',
    text: '#1483B8B8',
    text100: '#1483B840',
    bg: '#F5FCFF',
    bg100: '#189DDD05',
    border: '#bbd4e0',
    border100: '#1483B814',
    main: {
      50: 'hsl(199, 80%, 10%)',
      100: 'hsl(199, 80%, 19%)',
      200: 'hsl(199, 80%, 28%)',
      300: 'hsl(199, 80%, 34%)',
      400: 'hsl(199, 80%, 40%)',
      500: '#189DDD',
      600: 'hsl(199, 80%, 58%)',
      700: 'hsl(199, 80%, 68%)',
      800: 'hsl(199, 80%, 78%)',
      900: '#1483B8',
    },
  },
  parent: {
    primary: '#01A262',
    text: '#01A262B8',
    text100: '#01A26240',
    bg: '#01A26214',
    bg100: '#01A26205',
    border: '#cce8dd',
    border100: '#01A26214',
    // border: "#01A26214",
    main: {
      50: 'hsl(156, 99%, 10%)',
      100: 'hsl(156, 99%, 14%)',
      200: 'hsl(156, 99%, 18%)',
      300: 'hsl(156, 99%, 22%)',
      400: 'hsl(156, 99%, 28%)',
      500: '#01A262',
      600: 'hsl(156, 99%, 42%)',
      700: 'hsl(156, 99%, 52%)',
      800: 'hsl(156, 99%, 62%)',
      900: '#018C55',
    },
  },
  child: {
    primary: '#111',
    text: '#000',
    text100: '#111',
    bg: '#fff',
    bg100: '#fff',
    border: '#111',
    border100: '#11111180',
    main: {
      50: 'hsl(156, 99%, 0%)',
      100: 'hsl(156, 99%, 1%)',
      200: 'hsl(156, 99%, 2%)',
      300: 'hsl(156, 99%, 3%)',
      400: 'hsl(156, 99%, 4%)',
      500: '#111',
      600: 'hsl(156, 99%, 66%)',
      700: 'hsl(156, 99%, 77%)',
      800: 'hsl(156, 99%, 88%)',
      900: 'hsl(156, 99%, 98%)',
    },
  },
};

export const Routes = {
  landing: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  register: '/register',
  onboarding: '/onboarding',

  // private
  dashboard: '/dashboard',
  performance: '/performance',
  children: '/children',
  realChildren: '/real-children',
  childProfile: (param?: string) => {
    if (param) {
      return `/children/child/${param}`;
    }
    return '/children/child/:uuid';
  },
  studentProfile: (param?: string) => {
    if (param) {
      return `/children/student/${param}`;
    }
    return '/children/student/:uuid';
  },
  quizAttempt: (studentId?: string, quizAttemptId?: string) => {
    if (quizAttemptId || studentId) {
      return `/children/student/${studentId}/quiz-attempt/${quizAttemptId}`;
    }
    return `/children/student/:studentId/quiz-attempt/:quizAttemptId`;
  },
  subscription: '/subscription',
  account: '/account',

  sample: `${VITE_PAR_CHILD_WEBSITE_LINK}/sample?tour=true`,
};

export const OrganizationTypes = [
  { label: 'Parent', value: 'parent' },
  { label: 'School', value: 'school' },
  { label: 'Religious Center', value: 'religious_center' },
  { label: 'Playground', value: 'playground' },
  { label: 'Society', value: 'society' },
];

export const OrganizationKids = [
  { label: '10 - 99', value: '10 - 99' },
  { label: '100 - 350', value: '100 - 350' },
  { label: '351 - 500', value: '351 - 500' },
  { label: '501 - 1000', value: '501 - 1000' },
  { label: '1000 - 5000', value: '1000 - 5000' },
];

export enum ApiMethods {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export const DefaultDeviceData = {
  email: 'device@mail.com',
  dateOfBirth: '2000-01-01',
};

export const defaultPictureUrl =
  'https://api.dicebear.com/5.x/icons/svg?seed=testerzero-czgd3-gmail-29f9c-com&size=200&radius=50';
